//ver 1.3 GT ga360	
//kotwice z nawigacji + pv i vpv
console.log('v1.3.1');

var activeSlug;
var isScrolling = false,// gdy strona się scrolluje to zmienna ma wartość true i nie wysyłamy statów na hover np. akordeon, hotpoint
    lastReportedSlug = null;
var wp_content_selector,
    firstArticleSlug = $('article').eq(0).data('id'),
    firstParagraphSlug = $('section.__js_section').eq(0).data('id');

(function () {
    window.dataLayer = window.dataLayer || [];

    var initSlug = document.location.pathname.split("/").pop();

    if (!document.getElementsByClassName('__js_section').length ||
        document.location.href.indexOf('.html') > 0) return;

    if (typeof(serviceBaseUrl) == "undefined") { // zabezpieczenie przed brakiem serviceBaseUrl
                                                 // dodawane po stronie backendu w html-u (serwis jest wystawiany z folderem w URLu)
        console.error('ERROR: serviceBaseUrl is no defined!');
        window.serviceBaseUrl = "";
    }
    
    activeSlug = initSlug;
    
    var customOffset = $('.header .wrapper').height() + 10,
        animationTime = 1000,
        $sections = $('.sections .__js_section'),

        // Przewijanie do sekcji slug jeżeli w URL jest ustawiony jakiś slug na starcie
        
        scrollOnStart = function () {
            var $target = null;

            // jeśli URL ma slug paragrafu (zaczyna się od "paragraf_")
            if (initSlug.startsWith('paragraf_')) {
                $target = $('#' + initSlug); // szukaj po id paragrafu
                if (!$target.length) {
                    $target = $('.__js_section[data-id="' + initSlug + '"]'); // fallback: data-id
                }
            }

            if ($target && $target.length) {
                // scroll do paragrafu
                $('html,body').animate({
                    scrollTop: $target.offset().top
                }, animationTime, 'easeOutExpo');
            } else {
                return;
            }

            // ustawienie aktywnego sluga i wysłanie statystyk
            changeActiveSlug(initSlug);
            sendStats('progress', 'start', initSlug);
        };

        // staty pageviews i scrollboost pwp ----- {
        
        reportSlugTS = -1,

        reportSlug = function() {
            if (lastReportedSlug === null) {
                
                //wyślij statystykę pageview standard
                
                wp_dot_addparams.ctags = statData[firstArticleSlug].tags;
                try {
                    dataLayer.push({
                        event: 'pageview',
                        page: {
                            pageviewType: 'standard',
                            error404: basicStatData.ga.page.error404,
                            templateType: 'AS'
                        },
                        site: {
                            name: basicStatData.ga.site.name,
                            version: basicStatData.ga.site.version,
                            cms: basicStatData.ga.site.cms,
                            as: {
                            orderId: asorderid,
                            productName: asproduct,
                            name: asname
                            }
                        },
                        content: {
                            title: statData[firstArticleSlug].title + ' ' + activeSlug,
                            category: {
                            IAB: statData[firstArticleSlug].category.IAB,
                            Gemius: statData[firstArticleSlug].category.Gemius
                            },
                            tags: statData[firstArticleSlug].tags
                        }
                    });
                }
                catch(e) { console.log('WP.pwp error: ' + e); }
                
            } else {
                // wyślij statystykę pageview scrolboost vpv. pageviewType ma wartość "overlay" 
                // gdy nie mamy doładowania i "scrollboost" gdy następuje doładowanie, ALE dla pseudo dynamicznych stron AS ma byc jednak scrollboost ;) - ustalone z Salestube !
                
                wp_content_selector = document.getElementById(lastReportedSlug);
                
                try {
                    WP.push(function () {
                        WP.stat.show(wp_sn, {"category": 'pageviewVpv', "label": 'scrollboost', "asproduct": asproduct, "asorderid": asorderid, "asname": asname }, 'pageviewVpv');
                    });
                }
                catch(e) { console.log('WP.statshow error: ' + e); }
                //sendStats('pageviewVpv', 'scrollboost', activeSlug); // musi isć dot ptrzed ustawieniem wp_content_selector
                
                unloadData(lastReportedSlug);
                wp_dot_addparams.ctags = statData[firstArticleSlug].tags;
                try {
                    dataLayer.push({
                        'event': 'pageviewVpv',
                        'page': {
                            'pageviewType': 'scrollboost',
                            'error404': basicStatData.ga.page.error404,
                            'templateType': 'AS'
                        },
                        'site': {
                            'name': basicStatData.ga.site.name,
                            'version': basicStatData.ga.site.version,
                            'cms': basicStatData.ga.site.cms,
                            'as': {
                            'orderId': asorderid,
                            'productName': asproduct,
                            'name': asname
                            },
                            'frontendPlatform': 'other'
                        },
                        'content': {
                            'title': statData[firstArticleSlug].title + ' ' + activeSlug,
                            'category': {
                            'IAB': statData[firstArticleSlug].category.IAB,
                            'Gemius': statData[firstArticleSlug].category.Gemius
                            },
                            'tags': statData[firstArticleSlug].tags
                        }
                    });
                }
                catch(e) { console.log('WP.pwp.error: ' + e); }
            }
            
            lastReportedSlug = activeSlug;
            reportSlugTS = -1;
        },
        
        // ----- }
        

        changeActiveSlug = function(slug) {
            
            //if (!activeSlug || activeSlug.length<2) return;

            activeSlug = slug;

            $('.__js_section[data-id]').removeClass("__active");
            $('.__js_section[data-id='+activeSlug+']').addClass("__active");

            // history.pushState(
            //     { id: slug },
            //     $(this).attr('title'),
            //     serviceBaseUrl + "/" + slug + location.search
            // );
            console.log('PS');

            if (lastReportedSlug === null) { // jeżeli pierwsze wejście to wysyłaj pageview od razu
                reportSlug();

            } else if (lastReportedSlug != slug) { // jeżeli zmiana sluga to wysyłaj po sekundzie statystykę

                if (reportSlugTS >-1 ) clearTimeout(reportSlugTS);
                reportSlugTS = setTimeout(reportSlug, 1000);

            } else {
                if (reportSlugTS >-1 ) clearTimeout(reportSlugTS);
            }
        },

        // Sprawdzanie czy user zescrollował do sekcji. Jeżeli tak to ustawia pozycję w nawigacji
        sectionScrollCheck = function() {

            sectionScrollCheckTS = setTimeout(sectionScrollCheck, 200);
            
            var $W = $(window),
                topScroll = $W.scrollTop(),
                wHeight = $W.height();

            // wymuszenie strony głównej
            if (topScroll <= customOffset) {
                if ($sections.eq(0).attr('id') !== activeSlug) {  // jeśli ten sam co pierwszy to return
                    changeActiveSlug($sections.eq(0).attr('id'));
                }
                return;
            }

            for (var i=0; i<$sections.length; i++) {
                var $section = $sections.eq(i),
                    sectionOffset = $section.offset().top,
                    sectionHeight = $section.height();
                   
                if (activeSlug != $section.attr('id') &&
                    topScroll > sectionOffset - customOffset - 10 &&
                    topScroll < sectionOffset + sectionHeight - customOffset ) {
                    
                        changeActiveSlug($section.attr('id'));
                    
                    
                        break;
                }

            }
        },
        sectionScrollCheckTS = null,

        // Inicjalizacja metod dla obsługi nawigacji - clików i sprawdzanie scrolla, dodanie flagi podczas skrolowania
        initNavigation = function () {

            sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25 );

        };
     

    if (initSlug.length > 1 && initSlug !== "undefined") {
        setTimeout(scrollOnStart, 800);
    }

    initNavigation();
    
})();